var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D4F7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6751 7.25784C17.9409 7.64899 17.805 7.93933 17.6751 8.124L10.8635 17.9791C10.7986 18.0716 10.3366 18.124 10.2416 18.124C10.1465 18.124 10.0558 18.0716 9.99077 17.9791L6.76812 13.3958C6.49998 13 6.50004 12.5625 6.76794 12.3477C6.99996 12.0625 7.49999 12 7.67514 12.124L10.5 16L16.6751 7.12399C17 7.00001 17.4476 6.92283 17.6751 7.25784Z",
    fill: "#089163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenWithBg);
export default __webpack_public_path__ + "static/media/checkGreenWithBg.e4020430d48d0c77611b334d7f97b15d.svg";
export { ForwardRef as ReactComponent };